import React from "react";

import {CircularProgress, Stack, TabList, TabPanel, Tabs} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Tab from "@mui/joy/Tab";
import Chip from "@mui/joy/Chip";

// components
import AttachmentCategoryList from "./AttachmentCategoryList";
import BaseApi from "../../utils/BaseApi";
import AttachmentListItem from "./AttachmentListItem";
import CommonCopyToClipboard from "../Common/CommonCopyToClipboard";


class AttachmentsTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: null,
            fsDirectory: null
        };
    }

    async componentDidMount() {
        await this.updateAttachments();
        await this.retrieveCategories();
    }

    async updateAttachments() {
        const api = new BaseApi();
        if (this.props.appName === 'Opportunity'){
            const url = `opportunity/${this.props.appId}/update_attachments`;
            let response = await api.get(url, {});
            if (response.status === 200) {
                this.setState(
                    {
                        fsDirectory: response.data.fs_directory,
                        xtype_count: response.data.xtype_count,
                    }
                )
            }
        }
        else {
            const url = `attachment/count_xtype`;
            let response = await api.get(
                url, {
                    related_app: this.props.appName,
                    related_app_id: this.props.appId
                }
            );
            if (response.status === 200) {
                this.setState(
                    {
                        xtype_count: response.data.xtype_count,
                    }
                )
            }
        }
    }

    async retrieveCategories() {
        const url = `attachment/subscriber_xtypes`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let categories = []
        for (const category of response.data.all_xtypes) {
            if (response.data.available_xtypes.includes(category[0])){
                categories.push(category);
            }
        }
        this.setState(
            {
                categories: categories,
            }
        );
    }

    render(){
        if (!this.state.categories) {
            return(
                <>
                    <CircularProgress/>
                    <Typography>
                        Загрузка вкладки может занимать существенное время, не закрывайте окно и не переключайте вкладку!
                    </Typography>
                </>
            )
        }
        return(
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                }}
            >
                {
                    this.props.appName === 'Opportunity'?
                        <Chip
                            color={'warning'}

                        >
                            <Stack
                                direction={'row'}
                                spacing={2}
                                alignItems={'center'}
                            >
                                <CommonCopyToClipboard
                                    content={`\\\\fs\\crm-prod\\${this.state.fsDirectory}\\`}
                                />
                                {`Папка FS: \\\\fs\\crm-prod\\${this.state.fsDirectory}\\`}
                            </Stack>
                        </Chip>:
                        null
                }
                <Tabs
                    variant='soft'
                    orientation={'vertical'}
                    aria-label='Placement indicator tabs'
                    sx={{
                        minWidth: 200,
                    }}
                    defaultValue={this.state.categories[0][0]}
                >
                    <TabList
                        disableUnderline
                    >
                        {this.state.categories.map(each => {
                            return (
                                <Tab
                                    disableIndicator
                                    value={each[0]}
                                >
                                    {each[1]} {this.state.xtype_count?<Chip color={this.state.xtype_count[each[0]]?'primary':'neutral'}>{this.state.xtype_count[each[0]]}</Chip>:null}
                                </Tab>
                            )
                        })}
                    </TabList>
                    {this.state.categories.map((each) => {
                        return (
                            <TabPanel
                                value={each[0]}
                                variant={'soft'}
                                sx={{
                                    pt: 0,
                                    borderRadius: 'md',
                                    overflowY: 'scroll',

                                }}
                            >
                                <AttachmentCategoryList
                                    appId={this.props.appId}
                                    appName={this.props.appName}
                                    category={each[0]}
                                    fsDirectory={this.state.fsDirectory}
                                    itemComponent={AttachmentListItem}
                                    create={true}
                                />
                            </TabPanel>
                        )
                    })}
                </Tabs>
            </Stack>
        )
    }
}

export default AttachmentsTab